module.exports = __webpack_public_path__ + "img/ptb.51a1990a.png";